import React from "react";
import { useTheme } from "@mui/material";
import DSChip from "../../system-design/DSChip";

type ColorChipProps = {
  color: string;
  label?: string;
};

const getContrastColor = (hexColor: string): string => {
  const hex = hexColor.replace("#", "");

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? "#000000" : "#FFFFFF";
};

const ColorChip = ({ color, label }: ColorChipProps) => {
  const { spacing } = useTheme();

  const textColor = getContrastColor(color);
  const displayLabel = label || color;

  return (
    <DSChip
      label={displayLabel}
      sx={{
        backgroundColor: color,
        color: textColor,
        fontWeight: 600,
        fontSize: "12px",
        padding: spacing(0.5, 1),
        height: "auto",
        "& .MuiChip-label": {
          padding: spacing(0.5, 1),
        },
      }}
    />
  );
};

export default ColorChip;
